/**
 * 描述：指挥监控中心左侧导航指令
 * 作者：Bai.Zhiming
 * 日期：2017-8-18
 */
"use strict";
angular.module("commandMonitorLeftModule", []).
directive("commandMonitorLeft", ["$state", "trsHttpService", "$timeout", "$location", function($state, trsHttpService, $timeout, $location) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            selectedModule: "="
        },
        templateUrl: "./planningResource/commandMonitor/left/left_tpl.html",
        link: function(scope, $elem, $attr) {
            initStatus();
            initData();
            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    isExpand: $state.current.name.split(".")[2] === "commandMonitor",
                    selectedItem: $state.current.name.split(".")[3]
                };
                if (scope.status.isExpand) {
                    scope.$root.narrowNavigation = true;
                }
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getComMonitor();
            }
            /**
             * [selectItem description] 所选项名称
             * @return {[type]} [description]
             */
            scope.selectItem = function(itemName) {
                scope.$root.narrowNavigation = true;
                scope.status.selectedItem = itemName;
                scope.selectedModule = { value: "commandMonitor" };
            };
            /**
             * 监控是否切换到其他模块
             * @param  {[type]} newV  [description]
             * @param  {[type]} oldV) 
             * @return {[type]}       [description]
             */
            scope.$watch("selectedModule", function(newV, oldV) {
                if (angular.isUndefined(scope.selectedModule)) return;
                if (newV.value !== "commandMonitor") {
                    scope.status.selectedItem = '';
                    $elem.find('.newsLeve2').removeAttr('style');
                    scope.status.isExpand = false;
                }
            });

            scope.bindClick = function() {
                if (scope.status.isExpand) {
                    $elem.find('.newsLeve2').removeAttr('style');
                } else {
                    initHeight();
                }
                scope.status.isExpand = !scope.status.isExpand;
            }
            /**
             * 初始化子集高度
             * @return {[type]} [description]
             */
            function initHeight() {
                var leve2 = $elem.find('.newsLeve2');
                var item = leve2.find("li");
                var itemLen = item.length;
                var itemHeight = item.eq(0).height();
                leve2.height(itemHeight * itemLen);
            }
            /**
             * [getComMonitor description:获得指挥监控中心的左侧列表]
             * @return {[type]} [description]
             */
            scope.$on('changeCommandList', function() {
                getComMonitor();
            });

            function getComMonitor() {
                var comMonitorparams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'getaddfunclist'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), comMonitorparams, 'post').then(function(data) {
                    var item = data.menul ? data.menul : [];
                    scope.comList = [];
                    for (var i = 0; i < item.length; i++) {
                        var obj = item[i];
                        scope.comList[obj.sceneName] = obj.addFlg;
                    }
                    if ($state.current.name.split(".")[2] === "commandMonitor") {
                        $timeout(function() {
                            scope.selectedModule = { value: "commandMonitor" };
                            initHeight();
                            scope.status.selectedItem = $state.current.name.split(".")[3];
                        });
                    }
                });
            }
        }
    };
}]);